import { cast, getParent, types } from 'mobx-state-tree';
import { v4 as uuid } from 'uuid';
import { api } from 'src/api';
import { createAsync } from 'src/utils/asyncModel';
const applyRefundAsync = createAsync(body => {
  return async function applyRefund(options) {
    const resp = await api.Transaction.applyRefund(body, options);
    return resp;
  };
});
const checkPaymentAsync = createAsync(body => {
  return async function checkPayment(options) {
    const resp = await api.Transaction.checkPayment(body, options);
    return resp;
  };
});
const getAvaliableRefundAsync = createAsync(body => {
  return async function getAvaliableRefund(options) {
    const resp = await api.Transaction.getAvaliableRefund(body, options);
    const _getParent = getParent(this),
      transaction = _getParent.transaction;
    transaction.setAvailableRefundAmount(resp);
    return resp;
  };
});
const postCreditAsync = createAsync(body => {
  return async function postCredit(options) {
    const resp = await api.Transaction.postCredit(body, options);
    return resp;
  };
});
const postCustomChargeAsync = createAsync(body => {
  return async function postCustomCharge(options) {
    const resp = await api.Transaction.postCustomCharge(body, options);
    return resp;
  };
});
const postBulkCustomChargeAsync = createAsync(body => {
  return async function postBulkCustomCharge(options) {
    const resp = await api.Transaction.postBulkCustomCharge(body, options);
    return resp;
  };
});
const postCustomCreditAsync = createAsync(body => {
  return async function postCustomCredit(options) {
    const resp = await api.Transaction.postCustomCredit(body, options);
    return resp;
  };
});
const scheduledCustomTransactionAsync = createAsync(body => {
  return async function scheduledCustomTransaction(options) {
    const resp = await api.Transaction.scheduledCustomTransaction(body, options);
    return resp;
  };
});
const voidTransactionAsync = createAsync(body => {
  return async function voidTransaction(options) {
    const resp = await api.Transaction.voidTransaction(body, options);
    return resp;
  };
});
const verifyPaymentAsync = createAsync(body => {
  return async function verifyPayment(options) {
    const resp = await api.Transaction.verifyPayment(body, options);
    return resp;
  };
});
const getRecurringTransactionsAsync = createAsync(body => {
  return async function getRecurringTransactions(options) {
    const resp = await api.Transaction.getScheduledCustomTransaction(body, options);
    return resp;
  };
});
const updateRecurringTransactionsAsync = createAsync(body => {
  return async function updateRecurringTransactions(options) {
    const resp = await api.Transaction.putScheduledCustomTransaction(body, options);
    return resp;
  };
});
const cancelRecurringTransactionsAsync = createAsync(body => {
  return async function cancelRecurringTransactions(options) {
    const resp = await api.Transaction.putScheduledCustomTransactionStatus(body, options);
    return resp;
  };
});
const customTransactionsAsync = createAsync(body => {
  return async function customTransactions(options) {
    const resp = await api.Transaction.customTransactions(body, options);
    return resp;
  };
});
const BulkCustomChargeErrorElement = types.model({
  amount: types.maybeNull(types.union(types.number, types.string)),
  type: types.maybeNull(types.union(types.number, types.string)),
  utilityId: types.maybeNull(types.union(types.number, types.string)),
  propertyUtilityId: types.maybeNull(types.union(types.number, types.string)),
  notes: types.maybeNull(types.union(types.number, types.string)),
  memo: types.maybeNull(types.union(types.number, types.string)),
  notifyResident: types.boolean,
  title: types.maybeNull(types.union(types.number, types.string)),
  appfolioChargeOnDate: types.maybeNull(types.union(types.number, types.string)),
  propertyId: types.maybeNull(types.union(types.number, types.string)),
  userAccountId: types.maybeNull(types.union(types.number, types.string)),
  name: types.maybeNull(types.union(types.number, types.string)),
  number: types.maybeNull(types.union(types.number, types.string))
});
const TransactionStore = types.model('TransactionStore', {
  bulkCustomChargeErrorElement: types.optional(types.array(BulkCustomChargeErrorElement), []),
  availableRefundAmountValue: types.optional(types.number, 0),
  refundModalIsOpenValue: types.optional(types.boolean, false),
  refundTypeValue: types.optional(types.string, ''),
  transactionIdValue: types.optional(types.string, ''),
  updateDataValue: types.optional(types.string, ''),
  voidTransactionType: types.optional(types.string, ''),
  applyRefundAsync,
  checkPaymentAsync,
  getAvaliableRefundAsync,
  postCreditAsync,
  postCustomChargeAsync,
  postCustomCreditAsync,
  scheduledCustomTransactionAsync,
  verifyPaymentAsync,
  voidTransactionAsync,
  customTransactionsAsync,
  postBulkCustomChargeAsync,
  getRecurringTransactionsAsync,
  updateRecurringTransactionsAsync,
  cancelRecurringTransactionsAsync
}).actions(store => ({
  setBulkCustomChargeErrorElement(data) {
    store.bulkCustomChargeErrorElement = cast(data);
  },
  setAvailableRefundAmount(resp) {
    try {
      store.availableRefundAmountValue = resp.response.availableRefundAmount;
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  setRefundModalIsOpen(isOpen) {
    try {
      store.refundModalIsOpenValue = isOpen;
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  setVoidTransactionType(type) {
    try {
      store.voidTransactionType = type;
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  setRefundType(type) {
    try {
      store.refundTypeValue = type;
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  setTransactionId(id) {
    try {
      store.transactionIdValue = id;
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  setUpdateData() {
    try {
      store.updateDataValue = uuid();
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  }
})).views(store => ({
  get availableRefundAmount() {
    return store.availableRefundAmountValue;
  },
  get transactionId() {
    return store.transactionIdValue;
  },
  get refundModalIsOpen() {
    return store.refundModalIsOpenValue;
  },
  get refundType() {
    return store.refundTypeValue;
  },
  get updateData() {
    return store.updateDataValue;
  }
}));
export const transaction = types.optional(TransactionStore, {});